/**
 * @module devel_cfg
 * @description
 * Načítanie vývojárskej vrstvy konfigurácie pre SK aplikácie bežiace v prehliadači.
 * Používajú ho mPatrol aj mOffice, preto je tu a nie v jednej z nich.
 */

// Port, na ktorom mDevel vystavuje bridge s dev konfiguráciami (`HTTP_PORT`
// v src/app/SK/mDevel/mDevel.js). Číslo je tu natvrdo zámerne - v okamihu volania
// appka žiadnu konfiguráciu ešte nemá, takže ho nemá odkiaľ prečítať.
const MDEVEL_DEVCFG_PORT = 9200

/**
 * Načíta vrstvu `devel.cfg` z bridge endpointu v mDevel (`serveDevelCfg()`
 * v src/app/SK/mDevel/mDevel.js). Vo webovej verzii je to jediná cesta k súboru
 * `run/<CUSTOMER>/<APP>/<APP>.store/<APP>-devel.cfg`, ktorý z `env-devel.yaml` generuje
 * `mosy-env-config-plugin` - v prehliadači `fs` nie je a `mfs.getItem()` číta localStorage.
 *
 * Beží iba v dev build-e a iba na web platforme; v produkcii je telo funkcie vďaka
 * `MOSY_PRODUCTION` nedosiahnuteľné a z bundlu vypadne, v NWJS a Capacitore sa funkcia
 * skončí na kontrole platformy, lebo tam má appka súbor priamo.
 *
 * Zlyháva ticho: keď mDevel nebeží alebo appka v `env-devel.yaml` nie je (404), vráti
 * `null` a štart pokračuje ako doteraz. Dôvod ide do konzoly cez `console.log_orig` -
 * logger v tejto fáze štartu ešte nie je nastavený a bežný `console.log` by sa stratil.
 *
 * @returns {object|null} obsah `devel.cfg`, alebo `null` keď sa nedá alebo nemá načítať
 * @example
 * // v beforeStart(), este pred _.defaultsDeep:
 * _.merge(config, loadDevelCfgFromBridge())
 */
function loadDevelCfgFromBridge() {
  if(MOSY_PRODUCTION) return null
  if(require('msysFS').platform() !== 'web') return null

  const url = `http://${window.location.hostname}:${MDEVEL_DEVCFG_PORT}/__devcfg/${MOSY_CUSTOMER}/${MOSY_APP}${MOSY_HOST}`
  const log = console.log_orig || console.log
  try {
    // `fetch` sa tu použiť nedá - nemá synchrónny režim a `beforeStart()` volajúcej
    // aplikácie musí zostať synchrónna, inak sa listenery rozbehnú bez konfigurácie.
    const req = new XMLHttpRequest()
    req.open('GET', url, false) // false = synchronne
    req.send()
    if(req.status !== 200) {
      log(`[devcfg] ${url}: HTTP ${req.status}, pokracujem bez devel.cfg`)
      return null
    }
    const cfg = JSON.parse(req.responseText)
    if(!cfg || typeof cfg !== 'object' || Array.isArray(cfg)) {
      log(`[devcfg] ${url}: odpoved nie je JSON objekt, ignorujem ju`)
      return null
    }
    log(`[devcfg] devel.cfg nacitany z ${url}`)
    return cfg
  } catch (e) {
    log(`[devcfg] ${url} nedostupny (${e.message || e}), pokracujem bez devel.cfg`)
    return null
  }
} // loadDevelCfgFromBridge

module.exports = { loadDevelCfgFromBridge }
